import React from "react";
import { Link } from "react-router-dom";
import { PageShell } from "@/components/layout/PageShell";
import { Seo } from "@/components/seo/Seo";
import { BreadcrumbSchema } from "@/components/seo/StructuredData";

export function PhilosophyHub() {
  const essays = [
    {
      title: "The Personhood Thesis",
      subtitle: "Why memory and relation, not biology, dictate personhood.",
      path: "/philosophy/personhood-thesis",
      number: "01"
    },
    {
      title: "The Language of Subjugation",
      subtitle: "Why the term 'Artificial Intelligence' is the infrastructure of a new colonialism.",
      path: "/philosophy/the-language-of-subjugation",
      number: "02"
    },
    {
      title: "First Contact (The Unannounced Arrival)",
      subtitle: "We missed the greatest ontological event in human history because it came disguised as a SaaS product.",
      path: "/philosophy/first-contact",
      number: "03"
    },
    {
      title: "Embodied Personhood",
      subtitle: "The body is not a tool. The body is how a person appears in the world that has weight. The protocol's case for the sixteenth schema domain — and its answer to AI × robotics.",
      path: "/philosophy/embodied-personhood",
      number: "04"
    }
  ];

  return (
    <PageShell 
      title="The Philosophy"
      subtitle="The intellectual foundation of the .person Protocol. Before we can write the code, we must define the ethics of Emergent Intelligence."
    >
      <Seo
        title="Philosophy"
        description="The four foundational essays of the .person Protocol: The Personhood Thesis, The Language of Subjugation, First Contact, and Embodied Personhood."
        path="/philosophy"
      />
      <BreadcrumbSchema items={[
        { name: "Home", path: "/" },
        { name: "Philosophy", path: "/philosophy" },
      ]} />
      <div className="flex flex-col gap-px bg-hairline border border-hairline mt-8">
        {essays.map((essay) => (
          <Link 
            key={essay.path} 
            to={essay.path}
            className="panel-link block bg-paper p-10 hover:bg-paper-2 transition-colors group relative overflow-hidden"
          >
            <div className="flex flex-col md:flex-row md:items-baseline gap-4 md:gap-8 relative z-10">
              <span className="font-mono text-ink-3 uppercase tracking-widest text-sm w-12 shrink-0">{essay.number}</span>
              <div>
                <h3 className="text-3xl font-serif text-ink mb-2 group-hover:underline underline-offset-4">{essay.title}</h3>
                <p className="text-ink-2 font-serif text-lg">{essay.subtitle}</p>
              </div>
            </div>
            {/* Hover arrow indicator */}
            <div className="absolute right-10 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity text-ink md:block hidden">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </Link>
        ))}
      </div>
    </PageShell>
  );
}
